import convertSize from 'convert-size';

import { SlidingPanel } from 'core/components';
import { LEFT_MENU_WIDTH } from 'theme/constants';

import Image from './Image';
import TextEllipsis from './TextEllipsis';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string;
  fileName: string;
  subtitle?: string;
  fileSize?: number | null;
}

export const ImagePreview = ({
  isOpen,
  onClose,
  fileUrl,
  fileName,
  subtitle,
  fileSize,
}: IProps) => {
  const title = <TextEllipsis content={fileName} style={{ fontSize: '24px' }} lineHeight={32} />;

  const subtitleParts: string[] = [];
  if (subtitle) {
    subtitleParts.push(subtitle);
  }
  if (fileSize > 0) {
    subtitleParts.push(convertSize(fileSize));
  }
  const subtitleContent = subtitleParts.length > 0 ? subtitleParts.join(' • ') : undefined;

  return (
    <SlidingPanel
      isOpen={isOpen}
      onClosePanel={onClose}
      title={title}
      subtitle={subtitleContent}
      contentStyle={contentWrapperStyle}
      autoWidth
    >
      <Image
        src={fileUrl}
        alt={fileName}
        style={{
          height: '100%',
          width: 'auto',
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
        }}
      />
    </SlidingPanel>
  );
};

const contentWrapperStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  height: 'calc(100vh - 107px)',

  ['@media (min-width: 1610px)']: {
    width: 'calc(0.85 * 1440px)',
  },

  ['@media (max-width: 1610px)']: {
    width: `calc(0.85 * (100vw - ${LEFT_MENU_WIDTH}px - 2 * 24px))`,
  },
};
